import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { NewPlansComponent } from './pages/plans/new-plans/new-plans.component';
import { PaymentDetailsComponent } from './pages/plans/payment-details/payment-details.component';
import { PersonalDetailsComponent } from './pages/plans/personal-details/personal-details.component';
import { PayNowComponent } from './pages/pay-now/pay-now.component';
import { PreApprovalComponent } from './pages/pre-approval/pre-approval.component';
import { PayRecurringComponent } from './pages/pay-recurring/pay-recurring.component';

const routes: Routes = [
  { path: '', redirectTo: 'invalid', pathMatch: 'full' },
  // { path: 'customer', component: PatientDetailsComponent,
  //   children: [
  //     { path: '', redirectTo: 'personal/:token', pathMatch: 'full' },
  //     { path: 'payment/:token', component: PaymentComponent }
  //   ]
  // },     // commented because it is not used in any route
  {
    path: 'payment-proposal',
    loadChildren: () => import('./pages/send-proposal/send-proposal.module').then(m => m.SendProposalModule),
  },
  {
    path: 'payment-link',loadChildren: () => import('./pages/send-proposal/send-proposal.module').then(m => m.SendProposalModule)
  },
  
  
  { path: 'plans/:token', component: NewPlansComponent },
  
  { path: 'payment-details/:token', component: PaymentDetailsComponent },
  
  { path: 'personal-details/:token', component: PersonalDetailsComponent },
  
  { path: 'pay-now/:token', component: PayNowComponent },

  { path: 'credee-bill/:token',loadComponent: () => import('./pages/account-recievable/account-recievable.component').then(m => m.AccountRecievableComponent)},

  
  { path: 'payment-process/:token',loadComponent:()=>
    import('./pages/payment-process/payment-process.component').then(m=>m.PaymentProcessComponent)},

  { path: 'get-settlement/:token1/:token2',loadComponent:()=>
    import('./pages/pay-recurring/pay-settlement/pay-settlement.component').then(m=>m.PaySettlementComponent)},

    { path: 'upload_dl',loadComponent:()=>
    import('./pages/customer-details/customer-details/customer-details.component').then(m=>m.CustomerDetailsComponent)},


  { path: 'pay-recurring/:token',loadComponent:()=>
    import('./pages/pay-recurring/pay-recurring.component').then(m=>m.PayRecurringComponent)},
  
  // { path: 'pay-recurring/:token', component: PayRecurringComponent},

  { path: 'oauth-page',loadComponent:()=>
    import('./pages/bank-added/bank-added.component').then(m=>m.BankAddedComponent)}, // page removed from flow
  
  { path: 'pre-approval-application/:token/:id', component: PreApprovalComponent},
  { path: 'pre-approval-application/:token', component: PreApprovalComponent},
  
  
  //  { path: 'payment-completed', component: PaymentProcessCompletedComponent },
  //  { path: 'declined', component: PaymentProcessCompletedComponent },  // these two routes are kept commented may need in future


  { path: 'bank',loadComponent:()=>
    import('./pages/add-bank/add-bank.component').then(m=>m.AddBankComponent)},

  { path: 'add-card',loadComponent:()=>
    import('./pages/add-card/add-card.component').then(m=>m.AddCardComponent)
  },
  { path: 'add-subscription-card',loadComponent:()=>
    import('./pages/add-card-subscription/add-card-subscription.component').then(m=>m.AddCardSubscriptionComponent)
  },

  { path: 'finance-panel',loadComponent:()=>
    import('./pages/finance-panel/finance-panel.component').then(m=>m.FinancePanelComponent)},

  { path: 'consentForm',loadComponent:()=>
    import('./pages/consent-form/consent-form.component').then(m=>m.ConsentFormComponent)},
  
 { path: 'payment-completed',loadComponent:()=>
    import('./pages/payment-process-completed/payment-process-completed.component').then(m=>m.PaymentProcessCompletedComponent)},

  { path: 'declined',loadComponent:()=>
    import('./pages/payment-process-completed/payment-process-completed.component').then(m=>m.PaymentProcessCompletedComponent)},

  { path: 'open-url',loadComponent:()=>
    import('./pages/success-page/success-page.component').then(m => m.SuccessPageComponent)
  },

  { path: 'contribute',loadComponent:()=>
    import('./pages/contribute/contribute.component').then(m=>m.ContributeComponent)},

  { path: 'add-card-business/:token',loadComponent:()=>
    import('./pages/add-card-business/add-card-business.component').then(m=>m.AddCardBusinessComponent)},
    
  { path: 'cc-tilla/:contract_id',loadComponent:()=>
    import('./pages/c-tiila/c-tiila.component').then(m=>m.CTiilaComponent)},
    
  { path: 'tila',loadComponent: () =>
    import('./pages/iframe-tila/iframe-tila.component').then(m => m.IframeTllaComponent)},
  
  { path: 'remind-later/:token',loadComponent: () =>
    import('./pages/remind-later/remind-later.component').then(m => m.RemindLaterComponent)},
  
  
  { path: 'terms',loadComponent: () =>
    import('./pages/terms/terms.component').then(m => m.TermsComponent)},

  { path: 'thanks',loadComponent: () =>
    import('./pages/thanks/thanks.component').then(m => m.ThanksComponent)},

  { path: 'thanks/:token',loadComponent: () =>
    import('./pages/thanks/thanks.component').then(m => m.ThanksComponent)},
  
  
  { path: 'feedback',loadComponent: () =>
    import('./pages/feedback/feedback.component').then(m => m.FeedbackComponent)},

  { path: 'meet-link',loadComponent: () =>
    import('./pages/zoom-meet/zoom-meet.component').then(m => m.ZoomMeetComponent)},

  { path: 'download-multi-upload/:req_id', loadComponent: () =>
    import('./pages/success-page/success-page.component').then(m => m.SuccessPageComponent)
      },
  { path: 'download-file', loadComponent: () =>
    import('./pages/success-page/success-page.component').then(m => m.SuccessPageComponent)
    },
  { path: 'success-page', loadComponent: () =>
    import('./pages/success-page/success-page.component').then(m => m.SuccessPageComponent)
    },
  

  { path: 'verification',loadComponent: () =>
      import('./pages/otp-verification/verification/verification.component').then(c=>c.VerificationComponent)},

  { path: 'invalid',loadComponent: () =>
      import('./pages/invalid-link/invalid-link.component').then(c=>c.InvalidLinkComponent)},

  {
    path: 'practina/payment-process/:token', loadComponent: () =>
      import('./pages/practina/payment-process/payment-process.component').then(m => m.PaymentProcessComponent)
  },
  {
    path: 'practina/payment-options/:token', loadComponent: () =>
      import('./pages/practina-payment/practina-payment.component').then(m => m.PractinaPaymentComponent)
  },
  {
    path: 'practina/payment-options', loadComponent: () =>
      import('./pages/practina-payment/practina-payment.component').then(m => m.PractinaPaymentComponent)
  },
  {
    path: 'subscription', loadChildren: () => import('./pages/subscription-proposal/subscription-proposal.module').then(m=>m.SubscriptionProposalModule)
  },
  {
    path: 'review-us', loadComponent: () =>
      import('./pages/review-us/review-us.component').then(m => m.ReviewUsComponent)
  },
  {
    path: 'referral', loadComponent: () =>
      import('./pages/review-us/referral-link/referral-link.component').then(m => m.ReferralLinkComponent)
  },

  {
    path: 'ses-verification', loadComponent: () =>
      import('./pages/ses-verification/ses-verification.component').then(m => m.SesVerificationComponent)
  },

  { path: '**', component: NotFoundComponent },

];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
